import request from './api'
import { FlagInputTypes } from '../models/enums/FlagInputTypes';

export class FlagService {

    async addFlag(fixtureRoomId: string, inputId: string, time: number, notes: string, flagInput: FlagInputTypes, options: number[],refereeDecisions: number, refereeOffences: number, homePenalty: number, awayPenalty: number, playContinues: number) {
        console.log(refereeDecisions + ' , ' + refereeOffences)
        const response = await request({
            method: 'POST',
            url: `api/flags`,
            data: { fixtureRoomId, inputId, time, notes, flagInput, options, refereeDecisions, refereeOffences, homePenalty, awayPenalty, playContinues }
        });
        
        return response;
    }

    async updateFlag(flagId: string, fixtureRoomId: string, notes: string, options: number[],refereeDecisions: number, refereeOffences: number, homePenalty: number, awayPenalty: number, playContinues: number) {
        const response = await request({
            method: 'POST',
            url: `api/flags/${flagId}`,
            data: { fixtureRoomId, notes, options, refereeDecisions, refereeOffences, homePenalty, awayPenalty, playContinues }
        });

        return response;
    }

    async getFlagDetails(flagId: string) {
        const response = await request({
            method: 'GET',
            url: `api/flags/${flagId}`
        });
        return response;
    }

    async getFlagReasonsList() {
        const response = await request({
            method: 'GET',
            url: `api/flags/flagreasons`
        });

        return response;
    }
    
    async getRefereeDecision() {
        const response = await request({
            method: 'GET',
            url: `api/flags/refereeDecisions`
        });

        return response;
    }

    async getRefereeOffence() {
        const response = await request({
            method: 'GET',
            url: `api/flags/refereeOffences`
        });

        return response;
    }

    async deleteFlag(flagId: string) {
        const response = await request({
            method: 'DELETE',
            url: `api/flags/${flagId}`
        });

        return response;
    }

    static get instance() { return flagService }
}

const flagService = new FlagService();

export default flagService;